import { combineReducers } from 'redux';
import register from './register';
import login from './login';
import userMgmt from './users';
import rolesMgmt from './roles';
import projects from './projects';
import budget from './project_budget';
import forecast from './forecast';
import costTracking from './cost_tracking';
import claim from './claim';
import task from './task';
import variationRegister from './variation_register';
import paymentAct from './payment_act';
import segment from './segment';
import dashboard from './dashboard';
import report from './report';
import managementDashboard from './management_dashboard';
import costCode from './cost_code';

import costCodeImport from './cost_code_import';
import resourceCode from './resource_code';
import resourceCodeImport from './resource_code_import';
import estimationSheetImport from './estimation_sheet_import';
import loader from './loader';

import resourceAssignerImport from './resource_assigner_bulk_import';

export default combineReducers({
  global: combineReducers({
    login,
    loader,
    register,
    userMgmt,
    rolesMgmt,
    projects,
    budget,
    forecast,
    costTracking,
    claim,
    task,
    variationRegister,
    paymentAct,
    segment,
    dashboard,
    report,
    managementDashboard,
    costCode,
    costCodeImport,
    resourceCode,
    resourceCodeImport,
    estimationSheetImport,
    resourceAssignerImport,
  }),
});
